"use strict";
exports.__esModule = true;
exports.getIsOrganizer = void 0;
function getIsOrganizer(person) {
    return !!person.organizerId;
}
exports.getIsOrganizer = getIsOrganizer;
